import { Typography, Box, IconButton, Button, useTheme, Chip, TextField, Switch, FormControlLabel } from "@mui/material";
import { tokens } from '../../theme'
import DecimalInputGrid from "../../components/ajustes-precos/form-precos";
import { useState, useEffect, useCallback, useMemo } from "react";
import LockIcon from '@mui/icons-material/Lock';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import Divider from '@mui/material/Divider';

import { CircularProgress } from "@mui/material";
import { djangoApi } from "../../utils/axios/axios.utils";
import CardPrecos from "../../components/ajustes-precos/card-precos";

import { MenuItem, Select, InputLabel, FormControl, Checkbox, ListItemText, Pagination } from "@mui/material";
import { debounce, result } from "lodash";
import SaveIcon from '@mui/icons-material/Save';

import SpinnerPageLoader from "./loader-spinner";


const gridLayout = `50px 100px 100px 120px 120px 120px 120px 120px repeat(8, 120px) 140px`;

const ITEMS_PER_PAGE_OPTIONS = [25, 50, 75, 100, 150, 200];


const AjustesPrecoPage = () => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const [valuesForm, setValuesForm] = useState({
        brinco: '',
        correntaria: '',
        bracelete_anel: '',
        rodio_n: '',
        rodio_b: ""
    });

    const { brinco, correntaria, bracelete_anel, rodio_n, rodio_b } = valuesForm

    const [lockInput, setLockInput] = useState(false);
    const [dataToShow, setDataToShow] = useState([]);
    const [searchId, setSearchId] = useState("");


    useEffect(() => {
        console.log('valuesForm', valuesForm)
    }, [valuesForm]);

    const handleLock = () => {
        setLockInput((prev) => !prev)
    }
    const [loading, setLoading] = useState(false);

    function mergeArraysFromObject(data) {
        return Object.values(data).flat();
    }
    const [selected, setSelected] = useState([]);
    const [options, setOptions] = useState([]);

    const [selectedColor, setSelectedColor] = useState([]);
    const [colorsArray, setColorsArray] = useState([]);
    const [isPriceFilterEnabled, setIsPriceFilterEnabled] = useState(false);

    const [formValues, setFormValues] = useState([]);

    const handleChange = (event) => {
        setSelected(event.target.value);
    };
    const handleChangeColor = (event) => {
        setSelectedColor(event.target.value);
    };

    const handleTogglePriceFilter = (event) => {
        setIsPriceFilterEnabled(event.target.checked);
        // Apply filter logic here
    };

    // Debounce function to delay state updates
    // const debouncedSearch = useCallback(
    //     debounce((value) => {
    //         setSearchId(value);
    //     }, 300), // Adjust delay time in ms
    //     []
    // );

    // // Handle input change and pass value to debounced function
    // const handleSearchChange = useCallback((e) => {
    //     debouncedSearch(e.target.value);
    // }, [debouncedSearch]);

    const getProds = async () => {
        setLoading(true);
        const includeZero = false;
        try {

            const headers = {
                Authorization: `Token ${process.env.REACT_APP_DJANGO_TOKEN}`,
                "Content-Type": "application/json"
            };

            const [res, res2] = await Promise.all([
                djangoApi.get("products/register_prods/get_prods_ajustes_preco/", {
                    headers,
                    params: { include_zero: includeZero, should_return_other_prods: true }
                }),
                djangoApi.get("products/register_prods/get_all_kitprods_open_update_price/", { headers })
            ]);


            console.log('res2: ', res2)
            const result2 = res2.data.dados.data
            console.log('result2, here', result2)
            const normalizedRes2 = result2.map(item => ({
                // Core product identity fields
                id_produto: item.product_id_produto,
                color__color: item.product_id_produto_color ?? null,
                style: null,
                detailing: null,
                supplier__name: null,        // These don't exist in res2
                id_supplier: null,

                // Inventory
                initial_inventory: item.initial_inventory ?? null,
                quantity_available: null,    // You don't have this in res2, but exists in res
                quantity: item.quantity,

                // Prices
                cost_price: item.product_cost_price ? item.product_cost_price : 0,
                suggested_price: null,
                charged_price: item.sell_price ? item.sell_price : 0,

                // Dates
                purchase_date: null,

                // Other fields
                rodio_n: item.product_rodio_n ? item.product_rodio_n : 0,
                rodio_b: item.product_rodio_b ? item.product_rodio_b : 0,
                weight: item.product_weight ? item.product_weight : 0,
                plated: item.product_plated ?? null,
                seller_name: item.kit__seller__nome ?? null,

                // ID
                pk: item.pk,
                model: item.content_type__model ?? null,
                imageUrl: item.imageUrl ?? null
            }));

            console.log('result2, here after normalize', normalizedRes2)

            const { dados } = res.data;
            const newArrBeforeMerge = mergeArraysFromObject(dados);

            // First, group the inventory by id_produto + color and sum the quantities
            const inventoryMap = new Map();

            newArrBeforeMerge.forEach(item => {
                const key = `${item.id_produto}-${item.color__color ?? ''}`;
                const existing = inventoryMap.get(key);

                if (existing) {
                    existing.quantity_available += item.quantity_available ?? 0;
                } else {
                    inventoryMap.set(key, {
                        ...item,
                        quantity_available: item.quantity_available ?? 0,
                        quantity_sellers: 0,
                    });
                }
            });

            // Then, process the sellers' products and add to sellers quantity
            normalizedRes2.forEach(item => {
                const key = `${item.id_produto}-${item.color__color ?? ''}`;
                const existing = inventoryMap.get(key);
                const sellerQty = item.quantity ?? 0;

                if (existing) {
                    existing.quantity_sellers += sellerQty;
                    inventoryMap.set(key, existing);
                } else {
                    inventoryMap.set(key, {
                        ...item,
                        id_produto: item.id_produto,
                        color__color: item.color__color,
                        quantity_available: 0,
                        quantity_sellers: sellerQty
                    });
                }
            });

            // Final consolidated array
            const newArr2 = Array.from(inventoryMap.values());

            const changedPrice = res?.data?.changed_prods
            console.log('changed Price', changedPrice)

            console.log('estoque consolidado', newArr2)

            // const newArr = [...newArrBeforeMerge, ...normalizedRes2]

            // console.log('newArr', newArr)
            // Step 1: Create a map for fast lookup
            const serverMap = Object.fromEntries(
                changedPrice.map((item) => [item.id_produto, item])
            );

            // Step 2: Update the original array if matches found
            const newArr = newArr2.map((item) => {
                const match = serverMap[item.id_produto];
                if (match) {
                    return {
                        ...item,
                        charged_price: parseFloat(match.price),
                        quantity: match.quantity
                    };
                }
                return item;
            });


            const onlyModels = newArr.map((data) => data.model);
            const modelsUnique = [...new Set(onlyModels)];
            setOptions(modelsUnique);

            const onlyColor = newArr.map((data) => data.color__color);
            const colorsUnique = [...new Set(onlyColor)];
            setColorsArray(colorsUnique);

            // setDataToShow(newArr.slice(0, 2500))
            setDataToShow(newArr);
            console.log('dados:', typeof newArr);
        } catch (err) {
            window.alert(err);
            console.log("Erro ao alterar as aplicações", err);
            setLoading(false)
        } finally {
            // pass
            setLoading(false)
        }


    };

    const handleClick = async () => {
        setLoading(true);
        const dataTosend = formValues.map((data) => data.data)
        try {
            const res = await djangoApi.post(
                "products/register_prods/update_prods_value_bulket/",
                { data: dataTosend },  // Ensure correct payload structure
                {
                    headers: {
                        Authorization: `Token ${process.env.REACT_APP_DJANGO_TOKEN}`,
                        "Content-Type": "application/json"
                    }
                }
            );
            console.log("Response:", res);
            console.log("Status Code:", res.status);
            if (res.status === 201) {
                setFormValues([])
                getProds()
            }
        } catch (err) {
            window.alert(err);
            console.log("Erro ao alterar as aplicações", err);
            setLoading(false)
        } finally {
            // pass
            setLoading(false)
        }

    };

    useEffect(() => {
        const getProds = async () => {
            setLoading(true);
            const includeZero = false;
            try {

                const headers = {
                    Authorization: `Token ${process.env.REACT_APP_DJANGO_TOKEN}`,
                    "Content-Type": "application/json"
                };

                const [res, res2] = await Promise.all([
                    djangoApi.get("products/register_prods/get_prods_ajustes_preco/", {
                        headers,
                        params: { include_zero: includeZero, should_return_other_prods: true }
                    }),
                    djangoApi.get("products/register_prods/get_all_kitprods_open_update_price/", { headers })
                ]);


                console.log('res2: ', res2)
                const result2 = res2.data.dados.data
                console.log('result2, here', result2)
                const normalizedRes2 = result2.map(item => ({
                    // Core product identity fields
                    id_produto: item.product_id_produto,
                    color__color: item.product_id_produto_color ?? null,
                    style: null,
                    detailing: null,
                    supplier__name: null,        // These don't exist in res2
                    id_supplier: null,

                    // Inventory
                    initial_inventory: item.initial_inventory ?? null,
                    quantity_available: null,    // You don't have this in res2, but exists in res
                    quantity: item.quantity,

                    // Prices
                    cost_price: item.product_cost_price ? item.product_cost_price : 0,
                    suggested_price: null,
                    charged_price: item.sell_price ? item.sell_price : 0,

                    // Dates
                    purchase_date: null,

                    // Other fields
                    rodio_n: item.product_rodio_n ? item.product_rodio_n : 0,
                    rodio_b: item.product_rodio_b ? item.product_rodio_b : 0,
                    weight: item.product_weight ? item.product_weight : 0,
                    plated: item.product_plated ?? null,
                    seller_name: item.kit__seller__nome ?? null,

                    // ID
                    pk: item.pk,
                    model: item.content_type__model ?? null,
                    imageUrl: item.imageUrl ?? null
                }));

                console.log('result2, here after normalize', normalizedRes2)


                const { dados } = res.data;
                const newArrBeforeMerge = mergeArraysFromObject(dados);

                // First, group the inventory by id_produto + color and sum the quantities
                const inventoryMap = new Map();

                newArrBeforeMerge.forEach(item => {
                    const key = `${item.id_produto}-${item.color__color ?? ''}`;
                    const existing = inventoryMap.get(key);

                    if (existing) {
                        existing.quantity_available += item.quantity_available ?? 0;
                    } else {
                        inventoryMap.set(key, {
                            ...item,
                            quantity_available: item.quantity_available ?? 0,
                            quantity_sellers: 0,
                        });
                    }
                });

                // Then, process the sellers' products and add to sellers quantity
                normalizedRes2.forEach(item => {
                    const key = `${item.id_produto}-${item.color__color ?? ''}`;
                    const existing = inventoryMap.get(key);
                    const sellerQty = item.quantity ?? 0;

                    if (existing) {
                        existing.quantity_sellers += sellerQty;
                        inventoryMap.set(key, existing);
                    } else {
                        inventoryMap.set(key, {
                            ...item,
                            id_produto: item.id_produto,
                            color__color: item.color__color,
                            quantity_available: 0,
                            quantity_sellers: sellerQty
                        });
                    }
                });

                // Final consolidated array
                const newArr2 = Array.from(inventoryMap.values());

                const changedPrice = res?.data?.changed_prods
                console.log('changed Price', changedPrice)

                console.log('estoque consolidado', newArr2)

                // const newArr = [...newArrBeforeMerge, ...normalizedRes2]

                // console.log('newArr', newArr)

                // Step 1: Create a map for fast lookup
                const serverMap = Object.fromEntries(
                    changedPrice.map((item) => [item.id_produto, item])
                );

                // Step 2: Update the original array if matches found
                const newArr = newArr2.map((item) => {
                    const match = serverMap[item.id_produto];
                    if (match) {
                        return {
                            ...item,
                            charged_price: parseFloat(match.price),
                            quantity: match.quantity
                        };
                    }
                    return item;
                });

                const onlyModels = newArr.map((data) => data.model);
                const modelsUnique = [...new Set(onlyModels)];
                setOptions(modelsUnique);

                const onlyColor = newArr.map((data) => data.color__color);
                const colorsUnique = [...new Set(onlyColor)];
                setColorsArray(colorsUnique);

                // setDataToShow(newArr.slice(0, 2500))
                setDataToShow(newArr);
                console.log('dados:', typeof newArr);
            } catch (err) {
                window.alert(err);
                console.log("Erro ao alterar as aplicações", err);
                setLoading(false)
            } finally {
                // pass
                setLoading(false)
            }


        };
        getProds()
    }, []);

    const formatWord = (word) => {
        if (!word) return "";

        // Capitalize the first letter
        let formattedWord = word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();

        // Convert to singular if it ends with "s" (basic plural rule)
        if (formattedWord.endsWith("s") && !formattedWord.endsWith("ss")) {
            formattedWord = formattedWord.slice(0, -1);
        }

        return formattedWord;
    }

    const formatNumber = number => {
        return number?.toLocaleString("pt-br", {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        })
    }

    const filteredData = useMemo(() => {

        const incrementedData = dataToShow.map((data) => {
            // console.log('data', data)
            const rodioBdata = data?.rodio_b ? data?.rodio_b : 0
            const rodioNdata = data?.rodio_n ? data?.rodio_n : 0

            const rodioBranco = ((Number(rodio_b?.replace(',', '.')) || 0) * rodioBdata)
            const rodioNegro = ((Number(rodio_n?.replace(',', '.')) || 0) * rodioNdata)

            let newPrice = 0
            if (data.model === 'brinco') {
                console.log('Brinco rule')
                if (!brinco) {
                    newPrice = 0
                } else {
                    newPrice = (((data?.weight * Number(brinco.replace(',', '.'))) + rodioBranco + rodioNegro + (data?.cost_price - data?.plated)) * 5)
                }
            } else if (data.model === 'aneis' || data.model === 'bracelete') {
                if (!bracelete_anel) {
                    newPrice = 0
                } else {
                    newPrice = (((data?.weight * Number(bracelete_anel.replace(',', '.'))) + rodioBranco + rodioNegro + (data?.cost_price - data?.plated)) * 5)
                }
            } else {
                if (!correntaria) {
                    newPrice = 0
                } else {
                    newPrice = (((data?.weight * Number(correntaria.replace(',', '.'))) + rodioBranco + rodioNegro + (data?.cost_price - data?.plated)) * 5)
                }
            }
            return (
                {
                    ...data,
                    sugestedPrice: newPrice
                }
            )
        })

        return incrementedData.filter(data =>
            (selected.length === 0 || selected.includes(data.model)) &&
            (selectedColor.length === 0 || selectedColor.includes(data.color__color)) &&
            (searchId.length === 0 || data.id_produto.toString().includes(searchId)) &&
            (!isPriceFilterEnabled || data.sugestedPrice > data.charged_price) // Apply filter when enabled
        );
    }, [dataToShow, selected, selectedColor, searchId, brinco, correntaria, bracelete_anel, rodio_b, rodio_n, isPriceFilterEnabled]);


    const [currentPage, setCurrentPage] = useState(1);

    // Calculate start and end index
    const [itemsPerPage, setItemsPerPage] = useState(25); // Default to 25

    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    const paginatedData = filteredData.slice(startIndex, endIndex);


    const handleItemsPerPageChange = (event) => {
        setItemsPerPage(event.target.value);
        setCurrentPage(1); // Reset to first page when changing items per page
    };

    const handleValueChange = (data, value) => {
        const newValue = value;
        console.log('id value', data, newValue);
        const newId = `${data.model}-${data.pk}-${data.id_produto}`;

        setFormValues((prev) => {
            let updatedValues = [...prev]; // Copy the current state (array)

            // Check if the item already exists
            const existingIndex = updatedValues.findIndex(item => item.id === newId);

            if (newValue !== "") {
                const objToAdd = {
                    ...data,
                    newPrice: newValue
                };
                const newObj = { id: newId, data: objToAdd };

                if (existingIndex !== -1) {
                    // Update existing object
                    updatedValues[existingIndex] = newObj;
                } else {
                    // Add new object
                    updatedValues.push(newObj);
                }
            } else {
                // Remove existing object if value is invalid or empty
                updatedValues = updatedValues.filter(item => item.id !== newId);
            }

            return updatedValues;
        });
    };


    useEffect(() => {
        console.log('formValues', formValues)
    }, [formValues]);



    if (loading) {
        return (
            <SpinnerPageLoader />
        )
    }

    return (
        <Box
            mt={4}
            pt={4}
            pb={0}
            sx={{
                display: 'flex',
                flexDirection: 'column',
                // justifyContent: 'center',
                height: '100vh',
                overflow: "hidden", // Prevents scrolling
            }}
        >
            <Box
                sx={{
                    height: '120px',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '10px'
                }}
                pl={4}
            >
                <Box

                    sx={{
                        // marginBottom: '20px',
                        width: '100%',
                        justifyContent: options.length > 0 ? 'space-between' : 'flex-end',
                        display: 'flex',
                        flexDirection: 'row',
                        marginLeft: '-18px'
                    }}>
                    {
                        options.length > 0 && (
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    alignItems: 'center',
                                    gap: '20px'
                                }}
                            >
                                <FormControl sx={{
                                    minWidth: '200px',
                                    width: selectedColor.length < 2 ? "200px" : `${selectedColor.length * 80}px`,
                                    "& .MuiOutlinedInput-root": {
                                        "&:hover .MuiOutlinedInput-notchedOutline": {
                                            borderColor: "white", // Keeps border white on hover
                                        },
                                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                            borderColor: "white", // Keeps border white when focused
                                        }
                                    },
                                    "& .MuiInputLabel-root": {
                                        color: "white", // Keeps label white
                                        "&.Mui-focused": {
                                            color: "white", // Keeps label white when focused
                                        }
                                    }
                                }}>
                                    <InputLabel>Selecione o Tipo</InputLabel>
                                    <Select
                                        multiple
                                        value={selectedColor}
                                        onChange={handleChangeColor}
                                        renderValue={(selectedColor) => (
                                            <Box sx={{ display: 'flex', gap: 0.5 }}>
                                                {selectedColor.map((value) => (
                                                    <Chip key={value} label={value} size="small" />
                                                ))}
                                            </Box>
                                        )}
                                        sx={{ height: "40px", overflow: "hidden" }} // Fixes row height
                                    >
                                        {colorsArray.map((option) => (
                                            <MenuItem key={option} value={option}>
                                                <Checkbox checked={selectedColor.includes(option)} color="success" />
                                                <ListItemText primary={formatWord(option)} />
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                                <FormControl sx={{
                                    minWidth: '200px',
                                    width: selected.length < 2 ? "200px" : `${selected.length * 80}px`,
                                    "& .MuiOutlinedInput-root": {
                                        "&:hover .MuiOutlinedInput-notchedOutline": {
                                            borderColor: "white", // Keeps border white on hover
                                        },
                                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                            borderColor: "white", // Keeps border white when focused
                                        }
                                    },
                                    "& .MuiInputLabel-root": {
                                        color: "white", // Keeps label white
                                        "&.Mui-focused": {
                                            color: "white", // Keeps label white when focused
                                        }
                                    }
                                }}>
                                    <InputLabel>Selecione Tabela</InputLabel>
                                    <Select
                                        multiple
                                        value={selected}
                                        onChange={handleChange}
                                        renderValue={(selected) => (
                                            <Box sx={{ display: 'flex', gap: 0.5 }}>
                                                {selected.map((value) => (
                                                    <Chip key={value} label={value} size="small" />
                                                ))}
                                            </Box>
                                        )}
                                        sx={{ height: "40px", overflow: "hidden" }} // Fixes row height
                                    >
                                        {options.map((option) => (
                                            <MenuItem key={option} value={option}>
                                                <Checkbox checked={selected.includes(option)} color="success" />
                                                <ListItemText primary={formatWord(option)} />
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                                <TextField
                                    label="Procure um ID"
                                    size="small"
                                    variant="outlined"
                                    value={searchId}
                                    onChange={(e) => setSearchId(e.target.value)}
                                    inputProps={{ maxLength: 6 }}
                                    fullWidth
                                    sx={{
                                        width: "150px",
                                        "& .MuiOutlinedInput-root": {
                                            "&:hover .MuiOutlinedInput-notchedOutline": {
                                                borderColor: "white", // Keeps border white on hover
                                            },
                                            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                                borderColor: "white", // Keeps border white when focused
                                            }
                                        },
                                        "& .MuiInputLabel-root": {
                                            color: "white", // Keeps label white
                                            "&.Mui-focused": {
                                                color: "white", // Keeps label white when focused
                                            }
                                        }
                                    }}
                                // margin="normal"
                                />
                                <Box
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        alignItems: 'center', // Ensures vertical alignment
                                        gap: 1 // Adjust spacing between label and switch
                                    }}
                                >
                                    <InputLabel sx={{ fontSize: '1rem' }}>Filtro por Preço</InputLabel>
                                    <FormControlLabel
                                        control={
                                            <Switch
                                                checked={isPriceFilterEnabled}
                                                onChange={handleTogglePriceFilter}
                                                color="success"
                                            />
                                        }
                                        label={isPriceFilterEnabled ? "Ativado" : "Desativado"}
                                    />
                                </Box>


                            </Box>
                        )
                    }

                    <Button
                        variant="contained"
                        color="success"
                        size="medium"
                        onClick={handleClick}
                        disabled={loading || formValues?.length === 0}
                        sx={{ width: '180px', color: 'whitesmoke', fontWeight: 'bold' }}
                        startIcon={!loading && <SaveIcon />} // Show only when not loading

                    >
                        {
                            formValues?.length === 0 ?
                                "Sem Alteração" :
                                loading ? <CircularProgress size={24} color="inherit" /> : `Salvar Produtos - ${formValues?.length}`
                        }

                    </Button>
                </Box>
                {/* <Divider /> */}
                {
                    dataToShow.length > 0 && (
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                paddingBottom: '10px',
                                marginTop: '19px'
                                // borderBottom: '0.5px white solid'
                            }}
                        >
                            <DecimalInputGrid
                                valuesForm={valuesForm}
                                setValuesForm={setValuesForm}
                                lockInput={lockInput}
                            />
                            <IconButton sx={{ marginLeft: "8px", marginRight: '8px' }} onClick={handleLock}>
                                {lockInput ? <LockIcon color="warning" /> : <LockOpenIcon color="success" />}
                            </IconButton>
                        </Box>
                    )
                }

            </Box>
            {
                dataToShow.length > 0 && (
                    <>
                        <Divider />
                        <Box
                            sx={{

                                display: 'flex',
                                flexDirection: 'column',
                                flexGrow: 1, // Takes remaining space
                                paddingTop: '10px',
                                overflowY: 'auto',  // Enables scrolling
                                backgroundColor: colors.pink[500],
                                // marginLeft: '-32px',
                                // marginRight: '-32px',
                                padding: '0px 0px 0px 0px',
                                width: '100%,',
                                minWidth: '1500px'
                            }}
                        >
                            <Box
                                sx={{
                                    display: 'grid',
                                    gridTemplateColumns: gridLayout,
                                    gap: '10px',
                                    alignItems: 'center',
                                    padding: '10px',
                                    paddingLeft: '20px',
                                    position: "sticky",
                                    top: 0,  // Keeps it at the top
                                    backgroundColor: colors.pink[800], // Ensures it doesn't become transparent
                                    zIndex: 900, // Keeps it above scrolling content
                                }}
                            >
                                <Typography sx={{ marginLeft: '-10px' }}>Index</Typography>
                                <Typography>Imagem</Typography>
                                <Typography>ID Produto</Typography>
                                <Typography>Tipo</Typography>
                                <Typography>Tabela</Typography>
                                <Typography>Compra Inicial</Typography>
                                <Typography>Estoque</Typography>
                                <Typography>Vendedoras</Typography>
                                <Typography>Custo UN</Typography>
                                <Typography>Peso</Typography>
                                <Typography>Banho</Typography>
                                <Typography>Ródio B</Typography>
                                <Typography>Ródio N</Typography>
                                <Typography>Preço Custo</Typography>
                                <Typography>Preço Venda</Typography>
                                <Typography>Sugestão</Typography>
                                <Typography>Novo Preço</Typography>

                            </Box>

                            {paginatedData.length > 0 &&
                                paginatedData.sort((a, b) => a.id_produto.localeCompare(b.id_produto)).map((data, i) => (
                                    <CardPrecos
                                        gridLayout={gridLayout}
                                        data={data}
                                        index={i}
                                        key={i}
                                        onValueChange={handleValueChange}
                                        newValue={formValues?.find((form) => form.id === `${data.model}-${data.pk}-${data.id_produto}`)?.data?.newPrice || ""}
                                    />
                                ))}
                        </Box>
                        <Box sx={{ display: "flex", justifyContent: "space-between", mt: 2, mb: 2, alignItems: 'flex-end' }}>
                            <Select
                                value={itemsPerPage}
                                onChange={handleItemsPerPageChange}
                                size="small"
                                sx={{ minWidth: 100, marginLeft: '20px' }}
                            >
                                {ITEMS_PER_PAGE_OPTIONS.map((option) => (
                                    <MenuItem key={option} value={option}>
                                        {option} Resultados
                                    </MenuItem>
                                ))}
                            </Select>

                            <Pagination
                                sx={{ margin: '0 auto' }}
                                count={Math.ceil(filteredData.length / itemsPerPage)} // Total pages
                                page={currentPage}
                                onChange={(event, value) => setCurrentPage(value)}
                                color="secondary"
                                variant="outlined"
                                shape="rounded"
                                size="large"
                                showFirstButton
                                showLastButton
                            />
                            <Typography variant="h5" sx={{ alignSelf: 'flex-end', marginRight: '20px', fontWeight: 'bold' }}>Total: {formatNumber(filteredData.length)}</Typography>
                        </Box>
                    </>
                )
            }
        </Box>
    );
}

export default AjustesPrecoPage;